import axios from '../BASE_API'
import AuthHeader from '../AuthHeader'
import { PackageList, PackagePost, PackageUpdate } from '../../app/models/Package'

class PackageService {

  getPackageList = () => {
    return axios.get('/package/list', { headers: AuthHeader() })
  }
  getApprovedSMSList = () => {
    return axios.get('/company-sms/approved-list', { headers: AuthHeader() })
  }
  getPendingSMSList = () => {
    return axios.get('/company-sms/pending-list', { headers: AuthHeader() })
  }
  getActivePackageList = () => {
    return axios.get('/package/activeList', { headers: AuthHeader() })
  }
  
  getPackageDetails = (id: number) => {
      return axios.get(`package/details/${id}`, { headers: AuthHeader() })
  }
  getCompanySMSDetails = (id: number) => {
      return axios.get(`/company-sms/details/${id}`, { headers: AuthHeader() })
  }

  getPackagePaymentDetails = (data:any) => {
      return axios.post(`/subscribed-package/my-package-payment-details`,data, { headers: AuthHeader() })
  }
  getPackagePaymentInvoice = (data:any) => {
      return axios.post(`/subscribed-package/my-package-payment-invoice-details`,data, { headers: AuthHeader() })
  }

  addPackage = (data: PackagePost) => {
    return axios.post('/package/add', data, { headers: AuthHeader() })
  }

  getAllPackageList = (data: PackageList) => {
    return axios.post('/subscribed-package/my-package-payment-list', data, { headers: AuthHeader() })
  }

  updatePackage = (data: PackageUpdate) => {
    return axios.put('/package/update', data, { headers: AuthHeader() })
  }
 
  deletePackage = (id: number) => {
    return axios.delete(`/package/delete`, {
      data: {
        id: id,
      },
      headers: AuthHeader(),
    })
  }

  changePackageStatus = (id: number) => {
    return axios.put(`/package/changeStatus`, { id: id }, { headers: AuthHeader() })
  }
  declineSMSRequest = (id: number) => {
    return axios.post(`/company-sms/decline-request`, { id: id }, { headers: AuthHeader() })
  }
  changeCompanySMSStatus = (id: number) => {
    return axios.put(`/company-sms/change-status`, { id: id }, { headers: AuthHeader() })
  }

  approveSMS = (data: any) => {
    return axios.post('/company-sms/assign-sender-id', data, { headers: AuthHeader() })
  }

}

export default new PackageService()
